import React, { useState } from "react";
import Header from "../../Components/HeaderAdmin/Header";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import { addStaff } from "../../Api/staff";
import { getErrorByField } from "../../Api/auth";
function StaffAdd() {

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);

    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);
    const [apicall, setApicall] = useState(false);

    const initData = {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        password: "",
        facebook_id: "https://www.facebook.com/1000",
        twitter_id: "https://www.twitter.com/1000",
        instagram_id: "https://www.instagram.com/1000",
        role_id: "",
        confirmPassword: ""
    };
    const [formData, setFormData] = useState(initData);

    const dataChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }



    const handleSubmit = async (e) => {
        setApicall(true);
        const data = formData;
        addStaff(data, e).then((res) => {
            console.log(res);
            if (!res.data.status) { setErrors(res.data.error); }
            else {
                setApicall(false);
                handleShow();
                setFormData(initData);
                setValidated(false);
                window.location.href = "/staff";
                return;
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    };


    return (
        <>
            <Modal
                show={show} // Show the modal when `show` is true
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="logo-modal mb-4 text-center">
                        <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                    </div>
                    <h3 className="text-center">
                        staff add successfully
                    </h3>
                </Modal.Body>
            </Modal>
            <div className="main-page-body-content-header">
                <Header />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                        <h3>New Staff</h3>
                                    </div>
                                    <div className="dashboard-sec">
                                        <div className="container-fulid">
                                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                                <div className="form-box-section mt-4">
                                                    <div className="form-box-inner">
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <div className="col-md-6">
                                                                    <label className="dashboard-form-lable">Name</label>
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    placeholder="First"
                                                                    required
                                                                    className={`form-control dashboard-input-box-1 me-1  ${errors.length > 0 ? getErrorByField(errors, "firstname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                    value={formData.firstname}
                                                                    name={"firstname"}
                                                                    onChange={(e) => dataChange(e)} />
                                                                <input
                                                                    type="text"
                                                                    required
                                                                    className={`form-control dashboard-input-box-1 me-1  ${errors.length > 0 ? getErrorByField(errors, "lastname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                    placeholder="Last"
                                                                    value={formData.lastname}
                                                                    name={"lastname"}
                                                                    onChange={(e) => dataChange(e)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <div className="col-md-4">
                                                                    <label className="dashboard-form-lable">Email</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <Form.Control
                                                                        type="email"
                                                                        className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'email').length > 0 ? 'is-invalid' : ''}`}
                                                                        placeholder="Email Address"
                                                                        name="email"
                                                                        required
                                                                        value={formData.email}
                                                                        onChange={(e) => dataChange(e)} />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {
                                                                            errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                                                                return item.message;
                                                                            }) : "Please enter valid email"
                                                                        }
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <div className="col-md-4">
                                                                    <label className="dashboard-form-lable">Phone</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <input
                                                                        type="number"
                                                                        placeholder="Phone Number"
                                                                        required
                                                                        className={`form-control dashboard-input-box ${errors.length > 0 ? getErrorByField(errors, "phone").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        value={formData.phone}
                                                                        name={"phone"}
                                                                        onChange={(e) => dataChange(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <div className="col-md-4">
                                                                    <label className="dashboard-form-lable">Password</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <input
                                                                        type="password"
                                                                        placeholder="Password"
                                                                        required
                                                                        className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "password").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        value={formData.password}
                                                                        name={"password"}
                                                                        onChange={(e) => dataChange(e)} />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {
                                                                            errors.length > 0 ? getErrorByField(errors, "password").map((item) => {
                                                                                return item.message;
                                                                            }) : "Please enter password"
                                                                        }
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <div className="col-md-4">
                                                                    <label className="dashboard-form-lable">Confirm Password</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <Form.Control
                                                                        type="password"
                                                                        required
                                                                        className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "confirmPassword").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        placeholder="Confirm Password"
                                                                        value={formData.confirmPassword}
                                                                        name={"confirmPassword"}
                                                                        onChange={(e) => dataChange(e)}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {
                                                                            errors.length > 0 ? getErrorByField(errors, "confirmPassword").map((item) => {
                                                                                return item.message;
                                                                            }) : "Please enter confirmPassword"
                                                                        }
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <div className="col-md-4">
                                                                    <label className="dashboard-form-lable">Role</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <select
                                                                        value={formData.role_id}
                                                                        name={"role_id"}
                                                                        required
                                                                        className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "role_id").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        onChange={(e) => dataChange(e)}>
                                                                        <option >Select Role</option>
                                                                        <option value={"2"}>Admin</option>
                                                                        {/* <option value={"1"}>Fitter</option> */}
                                                                        <option value={"5"}>Staff</option>
                                                                        <option value={"7"}>Builder</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className="form-item" style={{ display: "none" }}>
                                                            <div className="form-group custom-form-group">
                                                                <div className="col-md-4">
                                                                    <label className="dashboard-form-lable" >Facebook Link</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <input
                                                                        type="text"
                                                                        required
                                                                        className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "facebook_id").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        placeholder="Facebook Link"
                                                                        value={formData.facebook_id}
                                                                        name={"facebook_id"}
                                                                        onChange={(e) => dataChange(e)} />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {
                                                                            errors.length > 0 ? getErrorByField(errors, "facebook_id").map((item) => {
                                                                                return item.message;
                                                                            }) : "Please enter facebook link"
                                                                        }
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-item" style={{ display: "none" }}>
                                                            <div className="form-group custom-form-group">
                                                                <div className="col-md-4">
                                                                    <label className="dashboard-form-lable">Instagram Link</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <input
                                                                        type="text"
                                                                        required
                                                                        className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "instagram_id").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        placeholder="Instagram Link"
                                                                        value={formData.instagram_id}
                                                                        name={"instagram_id"}
                                                                        onChange={(e) => dataChange(e)} />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {
                                                                            errors.length > 0 ? getErrorByField(errors, "instagram_id").map((item) => {
                                                                                return item.message;
                                                                            }) : "Please enter instagram link"
                                                                        }
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-item" style={{ display: "none" }}>
                                                            <div className="form-group custom-form-group">
                                                                <div className="col-md-4">
                                                                    <label className="dashboard-form-lable">Twitter Link</label>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "twitter_id").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        placeholder="Twitter Link"
                                                                        required
                                                                        value={formData.twitter_id}
                                                                        name={"twitter_id"}
                                                                        onChange={(e) => dataChange(e)} />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {
                                                                            errors.length > 0 ? getErrorByField(errors, "twitter_id").map((item) => {
                                                                                return item.message;
                                                                            }) : "Please enter twitter link"
                                                                        }
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>

                                                <div className="sec-btn-group add_customer_btn mt-4">
                                                    <Link to="/staff">
                                                        <button className="btn btn-cancel">Exit without saving</button>
                                                    </Link>
                                                    {apicall ? (
                                                        <button className="btn btn-save"><Spinner animation="border" className="border-black" /> </button>
                                                    ) : (
                                                        <button className="btn btn-save" type="submit">Save new Staff</button>)}
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StaffAdd;